import React from 'react';
import PropTypes from 'prop-types';

function RecommendationsSection({ recommendations }) {
  return (
    <div className="recommendations-section">
      <h3>🎯 Personalized Recommendations</h3>
      <div className="recommendations-list">
        {recommendations.map((rec, index) => (
          <div key={index} className="recommendation-item">
            <span className="rec-number">{index + 1}</span>
            <span 
              className="rec-text" 
              dangerouslySetInnerHTML={{ __html: rec }}
            ></span>
          </div>
        ))}
      </div>
    </div>
  );
}

RecommendationsSection.propTypes = {
  recommendations: PropTypes.array.isRequired,
};

export default RecommendationsSection;